import React, { Component } from 'react';

export class Tapasya2 extends Component {
  static displayName = Tapasya2.name;

  render () {
    return (
      <div>
        <section id="jeevan-parichay" className="container" style={{ marginTop: "60px", marginBottom: "80px" }}>
        <div className="card" style={{ padding: "34px 36px" }}>
          {/* Main Heading */}
          <h2 style={{color: "var(--accent)",textAlign: "center",fontSize: "clamp(26px,3vw,38px)",marginBottom: "18px",}}>
            🌼 अध्याय—5: बाल तेज, विद्रोह का शमन और श्मशान-तप का रहस्य 🌼
          </h2>

          {/* Intro */}
          <div style={{display: "flex",gap: "24px",alignItems: "center",flexWrap: "wrap",marginBottom: "18px",}}>
            {/* Image */}
            <div style={{ flex: "0 0 220px", textAlign: "center" }}>
              <div style={{width: "200px", height: "200px", borderRadius: "50%", overflow: "hidden", margin: "0 auto",border: "4px solid var(--accent)",boxShadow: "0 20px 60px rgba(0,0,0,0.6)"}}>
                <img src="/images/IMG_5427-removebg-preview.png" alt="Swami Brahmanand Saraswati Ji" style={{ width: "100%", height: "100%", objectFit: "cover" }}/>
              </div>
              <div style={{ marginTop: "10px", color: "var(--muted)", fontSize: "13px" }}>
                पूज्य स्वामी ब्रह्मानंद सरस्वती जी
              </div>
            </div>

            {/* Intro Text */}
            <div style={{ flex: 1, minWidth: "260px" }}>
              <p style={{ margin: 0, color: "rgba(255,235,200,0.95)", lineHeight: 1.8 }}>
                गया ज़िले के ग्रामीण क्षेत्र में उस समय हलचल मची हुई थी। स्वामी सहजानंद सरस्वती के विचारों से प्रेरित किसान आंदोलन अपनी चरम अवस्था में था। आनापुर, मघड़ा, पाण्डुई राज और अमांवां जैसे बड़े क्षेत्र इन लपटों से काँप उठे थे। इन्हीं दिनों टिकारी के निकट मल्डा ग्राम में जगदीश नारायण बाबू की जमींदारी के विरुद्ध भी विद्रोह की चिंगारी फूटी।<br/><br/>
                संयोग ऐसा कि उसी समय गुरुदेव के पिता तीर्थयात्रा हेतु मथुरा धाम गए हुए थे। यमद्वितीया का मुहूर्त चल रहा था— जो बिहार में अत्यंत पवित्र माना जाता है। घर में केवल माता जी थीं, और दूर-दराज से भयभीत लोगों की बातें सुन-सुनकर उनकी बेचैनी बढ़ती जा रही थी।
              </p>
            </div>
          </div>

          <hr style={{border: "none", height: "1px", background: "rgba(255,255,255,0.03)", margin: "18px 0 22px",}}/>

          {/* Narrative */}
          <div style={{ marginTop: "22px" }}>
            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>व्याकुलता के क्षण और अद्भुत आश्वासन</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              उसी भयाकुल वातावरण में मात्र १२–१५ वर्ष का एक बालक—ब्रह्म नारायण— माता के पास आया। उसके चेहरे पर आश्चर्यजनक स्थिरता थी, जैसे किसी गहन साधना से उठकर आया हो।
              
              धीमे परंतु दृढ़ स्वर में उसने कहा— “सरकार! आप निश्चिंत रहें— ओखनी के वे लोग आज ही साँझ तक स्वयं आकर क्षमा माँगेंगे।” गृहस्थ जीवन की सीमाओं में घिरी माता उसके शब्दों को असम्भव मानकर रोकती रहीं, परंतु उस क्षण उस बालक के भीतर मानो कोई दैवी प्रेरणा प्रवाहित हो रही थी।
              
              बालक बैलगाड़ी या संग-साथियों के बिना, केवल पिता की छड़ी हाथ में लिए घोड़े पर सवार होकर अकेला ही विद्रोहियों के बीच जा पहुँचा।
            </p>

            {/* More Sections */}
            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>किशोर की वाणी में धर्म-तेज</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              जब वह चैता ग्राम पहुँचा, किसान हथियारों और क्रोध से भरे जगदीश बाबू के निष्ठावान अनुयायी ‘जेठ रैयत’ पर आक्रमण करने की तैयारी में थे। सैकड़ों असंतुष्ट किसान— और सामने एक निडर बालक। मोमबत्ती की लौ की तरह काँपने के बजाय उसके भीतर तो मानो अग्नि जल रही थी— संयमित, तीखी और तेजस्वी। उसने भीड़ को रोका नहीं, बल्कि उनके बीच खड़ा होकर अद्भुत शांति से बोला। 
              उसकी वाणी में न तो भय था, न ही किसी प्रकार का अहंकार— परंतु इतना असर था कि सभी ने अपने कदम रोक दिए।
              फिर वह आंदोलन के युवा नेता पंडित यदुनंदन शर्मा से मिला— जो स्वामी सहजानंद सरस्वती जी के निकटतम सहयोगियों में से थे।
              ब्रह्म नारायण के तर्क, उसकी निर्भीकता, और उसके शब्दों की शुद्धता ने उस युवा अगुवा को भी चुप कर दिया। वे समझ नहीं पाए कि अल्पायु में इतनी प्रखरता कहाँ से आई।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>चमत्कारी साँझ और भविष्यवाणी का पूर्ण होना</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              साँझ होते-होते वही हुआ जिसकी घोषणा बालक ने सुबह कर दी थी। यदुनंदन शर्मा स्वयं सबसे आगे और सैकड़ों किसान पीछे— सभी पोखवां पहुँचकर माता जी से क्षमा याचना करने लगे।

यदुनंदन शर्मा ने बालक ब्रह्म नारायण के चरणों में झुककर कहा— “आज मैंने केवल एक बालक नहीं देखा। धर्म का वह प्रकाश देखा है, जो एक दिन समाज का मार्गदर्शक बनेगा।”

यह घटना उस तेजस्वी पुरुष के प्रकट होने का प्रारम्भिक संकेत थी— जो आगे चलकर केवल आध्यात्मिक ही नहीं, सामाजिक और नैतिक क्षेत्रों में भी लाखों लोगों के पथप्रदर्शक बने।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>गुरुदेव का श्मशान-तप — भय को भस्म करने वाली साधना</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              लोगों को यह अद्भुत प्रभाव अचानक प्रकट हुआ लगता था, परंतु वास्तव में यह गुरुदेव के कठोर तप और साधना का फल था।

युवावस्था में वे अक्सर श्मशान के एकांत में साधना किया करते थे। जहाँ साधारण मनुष्य का हृदय भय से काँप जाता है, गुरुदेव वहाँ ध्यान की गहरी अवस्थाओं में उतर जाते थे।

प्रेतभूमि, धुआँ, नीरवता और गहन अंधेरी रात— इन्हीं के बीच वे माँ बगलामुखी की साधना में लीन रहते।

माँ बगलामुखी— जो शत्रु-विनाशिनी, वाग्देवी और धर्म-संरक्षण की अधिष्ठात्री मानी जाती हैं।

उनकी साधना से गुरुदेव की वाणी में अद्भुत प्रभाव पैदा हो गया था— जो क्रोधित को शांत कर दे, और हिंसक को भी झुकने पर विवश कर दे।

श्मशान-तप ने उन्हें भय से परे कर दिया था, और बगलामुखी-आराधना ने उनकी वाणी को अजेय तेज से भर दिया था। इसी तेज का प्रत्यक्ष प्रमाण मल्डा के विद्रोह का सहज शांत होना था।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>अध्याय का सार</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              यह केवल एक ऐतिहासिक घटना नहीं, बल्कि एक दिव्य व्यक्तित्व के उदय का प्रथम प्रकटन था।

यह बताता है कि— बालक भी महापुरुष हो सकता है यदि उसके भीतर साधना का तेज हो। सत्य की शक्ति हथियारों से अधिक प्रबल है।

धर्म और तप मिलकर समाज को हिंसा से वापस शांति की ओर मोड़ सकते हैं। और श्मशान का एकांत, जहाँ सामान्य मनुष्य के मन में भय होता है, वहीं महापुरुष अपनी आत्मशक्ति का जन्मस्थान बनाते हैं।

यह अध्याय—उस दिव्य यात्रा का एक उज्ज्वल पड़ाव है जो आगे चलकर गुरुदेव को युगपुरुष के रूप में स्थापित करती है।
            </p>

            {/* <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>🌻 ज्ञान की वर्षा — जब ग्रंथ स्वयं खुलते थे</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              एक बार उन्होंने उपनिषद का एक कठिन मंत्र लिया और गहन ध्यान में बैठ गए। तीन दिन तक निराहार, निर्जल, पूर्ण मौन। जब आँखें खोलीं— उनके भीतर वह मंत्र ऐसे जीवित हो चुका था जैसे कोई चमकता सूर्य। अब वे शास्त्र पढ़ते नहीं थे— शास्त्र उनमें प्रकट होते थे। उनके गुरु ने कहा— “ब्रह्मन! तुमने केवल ज्ञान ग्रहण नहीं किया— ज्ञान बन गए हो।”
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>🌈 प्रथम दर्शन — आत्म-दीप्ति</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              तप के कई महीनों बाद एक भोर जब वह ध्यान में थे, उनकी चेतना अचानक मुक्त होने लगी। शरीर लुप्त सा लगा। अलगाव, मौन, समय— सब मिट गया। एक अद्भुत, अलौकिक, अवर्णनीय प्रकाश— और उस प्रकाश में उन्हें पहली बार अनुभव हुआ— “मैं शरीर नहीं हूँ। मैं शुद्ध चेतना हूँ।” यह था — आत्मसाक्षात्कार की प्रथम झलक। वही झलक जिसे पाने के लिए महर्षि दशकों तप करते हैं।
            </p>

            <h3 style={{ color: "var(--accent)", marginBottom: "8px" }}>🌺 वनवास की परिणति: अब वह किशोर नहीं — योगी था</h3>
            <p style={{ color: "var(--muted)", lineHeight: 1.86, textAlign: "justify" }}>
              कई महीनों की घोर साधना के बाद जब वह कुटिया से बाहर निकले, लोग पहचान ही न सके। कपड़ों से नहीं— आँखों से। उनकी आँखें स्थिर, शांत, और तेजस्वी थीं— जैसे किसी प्राचीन ऋषि की हों। घटना, भाव, दुख, भय— कुछ भी उन्हें छू नहीं पाता था। अब वह केवल ब्रह्म नारायण नहीं— ब्रह्मानंद बन चुके थे।
            </p> */}
          </div>

          {/* CTA */}
          <div style={{ textAlign: "center", marginTop: "26px" }}>
            <a href="#contact" className="btn" style={{ display: "inline-block" }}>
              आश्रम से संपर्क / श्रद्धांजलि
            </a>
          </div>
        </div>
      </section>
      </div>
    );
  }
}